import React, { useEffect, useState, useMemo, useRef } from 'react';
import styled from 'styled-components';
import T from 'components/common/text/T';
import { useShallowAppSelector } from 'store/hooks';
import { AuthActions } from 'store/actionCreators';
import { useDidUpdateEffect } from 'lib/utils';

import MuiButton from 'components/common/button/MuiButton';
import CustomSpan from 'components/common/text/CustomSpan';
import ArrowForwardIosRoundedIcon from '@material-ui/icons/ArrowForwardIosRounded';
import PlainModal from 'components/common/modal/PlainModal';
import AppModal from 'components/common/modal/AppModal';
import AccountTypeChangeModalContainer from './AccountTypeChangeModalContainer';

function ProfileAuthConnectContainer() {
  const {
    language,
    authProfileUrl: { connectUrl: profileUrl },
    authProfileUrlSuccess,
    authPasswordUrl: { connectUrl: passwordUrl },
    authPasswordUrlSuccess,
  }: {
    language: string;
    authProfileUrl: { connectUrl: string };
    authProfileUrlSuccess: boolean;
    authPasswordUrl: { connectUrl: string };
    authPasswordUrlSuccess: boolean;
  } = useShallowAppSelector(state => ({
    language: state.base.language,
    authProfileUrl: state.auth.connectAuthProfile.data || { connectUrl: {} },
    authProfileUrlSuccess: state.auth.connectAuthProfile.success,
    authPasswordUrl: state.auth.connectAuthPassword.data || { connectUrl: {} },
    authPasswordUrlSuccess: state.auth.connectAuthPassword.success,
  }));
  const { ipcRenderer } = window;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClickChangePassword = () => {
    AuthActions.connect_auth_password_request();
  };

  const handleClickModify = () => {
    AuthActions.connect_auth_profile_request();
  };

  const handleClickAccountTypeChange = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  useDidUpdateEffect(() => {
    if (!!authPasswordUrlSuccess) {
      const urlPath = `${passwordUrl}&page=password&language=${language}`;

      if (!ipcRenderer) {
        window.open(urlPath);
      } else {
        ipcRenderer.send('openBrowser', {
          url: urlPath,
        });
      }
    }
  }, [authPasswordUrlSuccess]);

  useDidUpdateEffect(() => {
    if (!!authProfileUrlSuccess) {
      const urlPath = `${profileUrl}&page=profile&language=${language}`;
      if (!ipcRenderer) {
        window.open(urlPath);
        // console.log('authProfileUrlSuccess open window ______');
      } else {
        ipcRenderer.send('openBrowser', {
          url: urlPath,
        });
        // console.log('authProfileUrlSuccess open electron ______');
      }
    }
  }, [authProfileUrlSuccess]);

  return (
    <ProfileAuthConnect data-component-name="ProfileAuthConnect">
      <h1 className="sr-only">Edit User Inforamtion</h1>
      <div className="ProfileButton__container">
        <div className="profileButton__descipt_box">
          <div className="profileButton__descipt_label">
            <T>EDIT_MEMBER_INFO</T>
          </div>
          <div className="profileButton__descipt_contents">
            <T>EDIT_MEMBER_INFO_DETAIL</T>
          </div>
        </div>
        <div className="profileButton__button_box">
          <MuiButton
            className="profileButton__button account_type"
            variant="contained"
            color="default"
            disableElevation
            onClick={() => {
              handleClickAccountTypeChange();
            }}
          >
            <CustomSpan fontSize={14} fontWeight={400}>
              <T>ACCOUNT_TYPE_CHANGE</T>
            </CustomSpan>
            <ArrowForwardIosRoundedIcon className="icon_arrow_right" />
          </MuiButton>
          <MuiButton
            className="profileButton__button info"
            variant="contained"
            color="default"
            disableElevation
            onClick={() => {
              handleClickModify();
            }}
          >
            <CustomSpan fontSize={14} fontWeight={400}>
              <T>MODIFY_INFO</T>
            </CustomSpan>
            <ArrowForwardIosRoundedIcon className="icon_arrow_right" />
          </MuiButton>
          <MuiButton
            className="profileButton__button password"
            variant="contained"
            color="default"
            disableElevation
            onClick={() => {
              handleClickChangePassword();
            }}
          >
            <CustomSpan fontSize={14} fontWeight={400}>
              <T>GLOBAL_PASSWORD_RESET</T>
            </CustomSpan>
            <ArrowForwardIosRoundedIcon className="icon_arrow_right" />
          </MuiButton>
        </div>
      </div>
      {useMemo(() => {
        return (
          <PlainModal isOpen={isModalOpen} onClose={handleCloseModal} width={1000}>
            <AppModal
              title={<T>ACCOUNT_TYPE_CHANGE</T>}
              content={<AccountTypeChangeModalContainer onCloseModal={handleCloseModal} />}
              contentCardStyle={{
                padding: '0 0 28px',
                backgroundColor: 'transparent',
              }}
              isCloseIcon={true}
              onClick={handleCloseModal}
              onCancel={handleCloseModal}
              hideButton={true}
            />
          </PlainModal>
        );
      }, [isModalOpen])}
    </ProfileAuthConnect>
  );
}

const ProfileAuthConnect = styled.section<{}>`
  .ProfileButton__container {
    width: 100%;
    border-radius: 15px;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 16%);
    padding: 40px;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    .profileButton__descipt_box {
      display: flex;
      column-gap: 40px;
      .profileButton__descipt_label {
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        color: #222;
      }
      .profileButton__descipt_contents {
        height: 50px;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        color: #444;
      }
    }

    .profileButton__button_box {
      display: flex;
      align-items: center;
      column-gap: 20px;
      .profileButton__button {
        width: 260px;
        height: 50px;
        padding: 0 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .icon_arrow_right {
          font-size: 16px;
        }
      }
    }
  }
`;
export default React.memo(ProfileAuthConnectContainer);
